import React from 'react'
import { SlotRedirect as LibSlotRedirect, SLOTS_MODAL_PATHS } from '@bcraft-frontend-lib/slots'

import { MODAL_ROUTE_PATH } from 'router/modalRoutes'

import { FreeSpinModal } from 'modules/SlotsRoot/components/FreeSpinModal/FreeSpinModal'

import {
  CheckEmailModal,
  ForgotPasswordModal,
  ResetPasswordConfirmModal,
  VerifyEmailSuccessModal,
} from 'modules/Emails'

import { SignInModal } from 'pages/Auth/modals/SignInModal'
import { SignUpModal } from 'pages/Auth/modals/SignUpModal'
import PaymentModal from 'pages/ProfilePage/components/PaymentModal/PaymentModal'
import {
  ConfirmActivateBonus,
} from 'pages/ProfilePage/pages/BonusPromotionsPage/ConfirmActivateBonus/ConfirmActivateBonus'
import DocumentUpload from 'pages/ProfilePage/pages/KycVerificationPage/Documents/DocumentUpload'

import { ChooseSport } from 'components/ChooseSport/ChooseSport'
import { LogoutConfirmModal } from 'components/LogoutConfirmModal'

interface IModalRoutesItem {
  id: string
  route: string | string[]
  Component: React.FC<any>
  bgColor?: string
  borderRadius?: number
  hideCloseBtn?: boolean
  noPaddings?: boolean
  customProps?: Record<string, unknown>
  isStatic?: boolean
}

export const modalRoutes: IModalRoutesItem[] = [
  {
    id: 'sign-in',
    route: MODAL_ROUTE_PATH.SIGN_IN,
    Component: SignInModal,
    borderRadius: 16,
    hideCloseBtn: true,
  },
  {
    id: 'sign-up',
    route: MODAL_ROUTE_PATH.SIGN_UP,
    Component: SignUpModal,
    hideCloseBtn: true,
  },
  {
    id: 'sign-up-with-code',
    route: MODAL_ROUTE_PATH.SIGN_UP_WITH_PROMOCODE,
    Component: SignUpModal,
    hideCloseBtn: true,
  },
  {
    id: 'reset-password-confirm',
    route: MODAL_ROUTE_PATH.RESET_PASSWORD_CONFIRM,
    Component: ResetPasswordConfirmModal,
    hideCloseBtn: true,
  },
  {
    id: 'verify-email-success',
    route: MODAL_ROUTE_PATH.VERIFY_EMAIL_SUCCESS,
    Component: VerifyEmailSuccessModal,
    hideCloseBtn: true,
  },
  {
    id: 'forgot-password',
    route: MODAL_ROUTE_PATH.FORGOT_PASSWORD,
    Component: ForgotPasswordModal,
    hideCloseBtn: true,
  },
  {
    id: 'check-email',
    route: MODAL_ROUTE_PATH.CHECK_YOUR_EMAIL,
    Component: CheckEmailModal,
    hideCloseBtn: true,
  },
  {
    id: 'confirm-activate-bonus',
    route: MODAL_ROUTE_PATH.CONFIRM_ACTIVATE_BONUS,
    Component: ConfirmActivateBonus,
    bgColor: 'transparent',
    hideCloseBtn: true,
  },
  {
    id: 'choose-sport',
    route: MODAL_ROUTE_PATH.CHOOSE_SPORT,
    Component: ChooseSport,
    bgColor: 'transparent',
    hideCloseBtn: true,
  },
  {
    id: 'deposit',
    route: [MODAL_ROUTE_PATH.DEPOSIT, MODAL_ROUTE_PATH.WITHDRAWAL],
    Component: PaymentModal,
    bgColor: 'transparent',
    hideCloseBtn: true,
  },
  {
    id: 'document-upload',
    route: MODAL_ROUTE_PATH.DOCUMENT_UPLOAD,
    Component: DocumentUpload,
    bgColor: 'transparent',
    hideCloseBtn: true,
  },
  {
    id: 'logout',
    route: MODAL_ROUTE_PATH.LOGOUT,
    Component: LogoutConfirmModal,
    borderRadius: 16,
    hideCloseBtn: true,
  },
  {
    id: 'free-spin-end',
    route: SLOTS_MODAL_PATHS.FREE_SPIN_END,
    Component: FreeSpinModal,
    customProps: {
      hideCloseBtn: true,
      bgColor: 'transparent',
    },
  },
  {
    id: 'slots-redirect',
    route: SLOTS_MODAL_PATHS.SLOTS_REDIRECT,
    Component: ({ path }: { path: string }) => React.createElement(LibSlotRedirect, { path }),
    customProps: {
      isFull: true,
    },
    isStatic: true,
  },
]
